import React, { FC } from 'react';

import {
  getGlobalContext,
  useContextWithValidation,
} from '@adsk/alloy-react-context';

import {
  getOrCreatePluginContext,
  getContextKey,
} from '../helpers/pluginContexts';
import useGetEntities from '../hooks/useGetEntities';
import { CommonReferencePickerPlugin } from '../types/ReferencePickerPlugin';

interface PluginEntitiesProviderProps {
  children: React.ReactNode;
  plugin: CommonReferencePickerPlugin;
  entityIds?: string[];
}

export const usePluginContext = (plugin: CommonReferencePickerPlugin) =>
  useContextWithValidation(
    getGlobalContext(
      getContextKey(plugin),
    ) as React.Context<CommonReferencePickerPlugin>,
    {
      hook: 'usePluginContext',
      provider: 'getContextKey(plugin)',
    },
  );

const PluginEntitiesProvider: FC<PluginEntitiesProviderProps> = ({
  children,
  plugin,
  entityIds = [],
}) => {
  const PluginContext = getOrCreatePluginContext(plugin);
  const contextValue = useGetEntities(plugin, entityIds);

  return (
    <PluginContext.Provider value={contextValue}>
      {children}
    </PluginContext.Provider>
  );
};

PluginEntitiesProvider.displayName = 'PluginEntitiesProvider';

export default PluginEntitiesProvider;
